<template>
    <div class="panel-body">
        <import-data :route="filterable.model" :json_fields="headers" :json_data="termos"></import-data>
        <div class="row">
            <div class="col-md-12">
                <advanced-filter ref="filter" v-bind="filterable">
                    <thead slot="thead">
                        <tr>
                            <th class="col-md-1">{{$t('words.options')}}</th>
                            <th>{{$t('attributes.description')}}</th>
                            <th>Data</th>
                            <th>Ativo?</th>
                        </tr>
                    </thead>
                    <tr slot-scope="{item, dropup}">
                        <td class="column-options">
                            <div class="btn-group" :class="{'dropup': dropup}">
                                <button type="button" class="btn btn-default btn-sm dropdown-toggle"
                                    v-bind:title="$t('words.operations')" data-toggle="dropdown" aria-haspopup="true"
                                    aria-expanded="false">
                                    <i class="fa fa-bars" aria-hidden="true"></i>
                                    <span class="caret"></span>
                                </button>
                                <div class="dropdown-menu">                                    
                                        <a class="dropdown-item" @click="detailsObject(item)">
                                            <i class="fa fa-eye"></i>
                                            {{$t('words.details') }}
                                        </a>                               
                                        <a class="dropdown-item" v-if="!item.termo_ativo" @click="aprovar(item)">
                                            <i class="fa fa-check"></i>
                                            Ativar
                                        </a>
                                        <router-link class="dropdown-item" v-if="!item.termo_ativo" :to="{ name: `termoEdit`, params: { id: item.id}}">
                                            <i class="fa fa-pencil"></i>
                                            {{$t('words.edit')}}
                                        </router-link>                                 
                                        <a class="dropdown-item" v-if="!item.termo_ativo" @click="deleteData(item.id, item.termo_descricao, 'termo')">
                                            <i class="fa fa-trash" aria-hidden="true"></i>
                                            {{$t('words.delete')}}
                                        </a>
                                </div>
                            </div>
                        </td>
                        <td>{{item.termo_descricao}}</td>
                        <td>{{formatDate(item.termo_data)}}</td>
                        <td>
                            <i v-if="item.termo_ativo" class="fa fa-check-circle-o text-green"></i>
                            <i v-if="!item.termo_ativo" class="fa fa-times-circle-o text-red"></i>
                        </td>
                    </tr>
                </advanced-filter>
            </div>
        </div>
        <show-data :description="description" :data="objectDetails" :headers="headers"></show-data>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                filterable: {
                    url: '/api/termos',
                    storeAction: 'setTermos',
                    storeName: 'termo.data',
                    model: 'termo',
                    showLinkDeleted: false
                },
                objectDetails: {},
                description: 'termo_descricao',
                headers: {
                    'Nome': 'termo_descricao',
                    'Conteudo': 'termo_conteudo'
                }
            };
        },
        computed: {
            termos() {
                return this.$store.state.termo.data;
            }
        },
        watch: {
            $route(data) {
                if (data.name === 'termos') {
                    this.prepareComponent();
                }
            }
        },
        methods: {
            aprovar(item) {
                let span = document.createElement('span');
                span.innerHTML = `Tem certeza que deseja aprovar o termo <b> ${item.termo_descricao} ?</b> 
               <p><b style="color:red"> Opção irreversível!</b></p>`;
                 Swal.fire({
                title: 'Aprovar Termo',
                icon: 'question',
                html: span,
                allowOutsideClick: false,
                showCancelButton: true,
                cancelButtonText: trans('words.close'),
                confirmButtonText: trans('words.confirm'),
                confirmButtonClass: 'btn btn-success float-right',
                cancelButtonClass: 'btn btn-default btn-lg float-left',
                buttonsStyling: false,
                reverseButtons: true,
                showLoaderOnConfirm: true,
                    preConfirm: (confirm) => {
                        if (confirm) {
                            return this.$store
                                .dispatch('aprovarTermo', item.id)
                                .then(response => {
                                    return response;
                                });
                        }
                    }
                }).then(response => {
                    if (!response.value) {
                        return;
                    }
                    let text = document.createElement('span');
                    text.innerHTML = response.value.message;
                    if (response.value.status === 'success') {
                        this.$prepareComponent();
                        this.successSwal(response.value);
                    } else {
                        this.errorSwal(response.value);
                    }
                }); 
            },          
        }
    };
</script>